export { default } from './DenFraudes';
